import { Pipe, PipeTransform } from '@angular/core';
import { ProductConfigurationFacade } from '@features/client/order-workflow/facades/product-configuration.facade';
import { flatten } from 'lodash';
import { ToothStateHighlightPipe } from '@features/client/order-workflow/pipes/tooth-state-highlight.pipe';
import { Observable, of } from 'rxjs';
import { ProductTypeMapItem } from '@features/client/order-workflow/models/product.model';
import { filter, map, switchMap } from 'rxjs/operators';
import { ToothCross } from '@features/client/order-workflow/models/tooth.model';
import { jawTeeth } from '@features/client/order-workflow/configs/jaw-teeth.config';

@Pipe({
  name: 'jawStateDisabled',
})
export class JawStateDisabledPipe implements PipeTransform {
  public jaws = {
    upper: jawTeeth.upperJaw,
    lower: jawTeeth.lowerJaw,
  };

  constructor(
    private readonly productConfigurationFacade: ProductConfigurationFacade,
    private readonly toothStateHighlight: ToothStateHighlightPipe,
  ) {}

  public transform(selectedJaw: string): Observable<boolean> {
    return this.productConfigurationFacade.getProductType().pipe(
      switchMap((productTypeMapItem: ProductTypeMapItem) => {
        if (!productTypeMapItem?.product_id) {
          return of(true);
        } else {
          const productId = productTypeMapItem.product_id;

          const allowedToothPositions = productTypeMapItem.product.toothCrossZones.reduce((acc, toothCrossZone) => {
            return [...acc, ...toothCrossZone.teeth];
          }, []);

          if (
            allowedToothPositions.length > 0 &&
            !this.jaws[selectedJaw].some((toothNumber) => {
              return allowedToothPositions.includes(toothNumber);
            })
          ) {
            return of(true);
          }

          return this.productConfigurationFacade.getToothCross().pipe(
            filter(Boolean),
            map((toothCross: ToothCross) => {
              const teeth = flatten(
                toothCross.groups.map((group) => {
                  return group.teeth;
                }),
              );
              const jawTeeth = teeth.filter((tooth) => {
                return this.toothStateHighlight.transform(selectedJaw, tooth.number);
              });
              const configurableTooth = jawTeeth.some((tooth) => {
                const availableOrderProduct = tooth.crown.orderProducts.find((orderProduct) => {
                  return orderProduct.product_id === productId;
                });

                return !tooth.crown.orderProducts.length || !availableOrderProduct?.is_configured;
              });

              return !configurableTooth;
            }),
          );
        }
      }),
    );
  }
}
